const objectAsString = (item, properties) =>
  properties.reduce((acc, it) => `${acc}${item[it]}`, '');
const objectHasAllProperties = (item, properties) =>
  properties.reduce((acc, it) => acc && item[it], true);

export const checkArrayForDuplicates = (array: any[], properties: string[]): boolean =>
  array?.reduce(
    (accumulator, item, index, array) =>
      !!(
        objectHasAllProperties(item, properties) &&
        array.find(
          (arrayItem, arrayItemIndex) =>
            index !== arrayItemIndex &&
            objectAsString(arrayItem, properties) === objectAsString(item, properties)
        )
      ),
    false
  );
